<template>
  <div class="ap-tabs" :class="{ 'ap-tabs--compact': compact }" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.tab"
      type="button"
      role="tab"
      class="ap-tab"
      :class="{ 'ap-tab--active': tab.tab === selected }"
      :aria-selected="tab.tab === selected"
      :aria-label="tab.title"
      @click.stop="emit('select', tab.tab)"
    >
      <span class="material-icons ap-tab__icon" :style="{ color: ACTIVITY_TAB_STYLES[tab.tab].color }">{{ ACTIVITY_TAB_STYLES[tab.tab].icon }}</span>
      <span v-if="!compact || tab.tab === selected">{{ tab.title }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { ActivityTab } from '../../../utils/recordingActivity/recordingActivity';
import { ACTIVITY_TAB_STYLES } from '../../../utils/recordingActivity/tabStyles';

defineProps<{
  tabs: Array<{ tab: ActivityTab; title: string }>;
  selected: ActivityTab;
  /** A phone's width: only the selected tab keeps its name, so all five fit without scrolling. */
  compact?: boolean;
}>();

const emit = defineEmits<{ (e: 'select', tab: ActivityTab): void }>();
</script>

<style scoped>
.ap-tabs {
  display: flex;
  gap: 2px;
  min-width: 0;
  padding: 3px;
  overflow-x: auto;
  scrollbar-width: none;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 999px;
}

.ap-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 5px 12px;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
  color: #fff;
  background: none;
  border: none;
  border-radius: 999px;
}

.ap-tab:hover {
  background: rgba(255, 255, 255, 0.08);
}

.ap-tab--active,
.ap-tab--active:hover {
  color: #17181d;
  background: #fff;
}

.ap-tab__icon {
  font-size: 16px;
}

.ap-tabs--compact .ap-tab:not(.ap-tab--active) {
  padding: 5px 9px;
}
</style>
